import HttpRequest from './HttpRequest';

export const getPhotos = async () => {
  try {
    const response = await HttpRequest.get('/photos');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
